"use client";

import { useEffect } from "react";
import { useFiltersStore } from "@/stores/filtersStore";

const COUNTRY_TO_CURRENCY: Record<string, string> = {
  GB: "GBP",
  AU: "AUD",
  NZ: "NZD",
  CA: "CAD",
  SE: "SEK",
  DK: "DKK",
  DE: "EUR",
  FR: "EUR",
  ES: "EUR",
  IT: "EUR",
  NL: "EUR",
  BE: "EUR",
  AT: "EUR",
  PT: "EUR",
  IE: "EUR",
  FI: "EUR",
  GR: "EUR",
  LU: "EUR",
  SK: "EUR",
  SI: "EUR",
  EE: "EUR",
  LV: "EUR",
  LT: "EUR",
  CY: "EUR",
  MT: "EUR",
  HR: "EUR",
  JP: "JPY",
  SG: "SGD",
  KR: "KRW",
  HK: "HKD",
};

const TIMEZONE_TO_COUNTRY: Record<string, string> = {
  "Europe/London": "GB",
  "Australia/Perth": "AU",
  "Australia/Sydney": "AU",
  "Australia/Melbourne": "AU",
  "Australia/Brisbane": "AU",
  "Australia/Adelaide": "AU",
  "Australia/Hobart": "AU",
  "Australia/Darwin": "AU",
  "Pacific/Auckland": "NZ",
  "America/Toronto": "CA",
  "America/Vancouver": "CA",
  "America/Montreal": "CA",
  "America/Edmonton": "CA",
  "America/Winnipeg": "CA",
  "Europe/Stockholm": "SE",
  "Europe/Copenhagen": "DK",
  "Europe/Berlin": "DE",
  "Europe/Paris": "FR",
  "Europe/Madrid": "ES",
  "Europe/Rome": "IT",
  "Europe/Amsterdam": "NL",
  "Europe/Brussels": "BE",
  "Europe/Vienna": "AT",
  "Europe/Lisbon": "PT",
  "Europe/Dublin": "IE",
  "Europe/Helsinki": "FI",
  "Europe/Athens": "GR",
  "Europe/Luxembourg": "LU",
  "Europe/Bratislava": "SK",
  "Europe/Ljubljana": "SI",
  "Europe/Tallinn": "EE",
  "Europe/Riga": "LV",
  "Europe/Vilnius": "LT",
  "Asia/Tokyo": "JP",
  "Asia/Singapore": "SG",
  "Asia/Seoul": "KR",
  "Asia/Hong_Kong": "HK",
};

const LS_KEY = "currencyAutoDetected";

const detectCountryFromTimezone = (): string => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return TIMEZONE_TO_COUNTRY[tz] ?? "US";
  } catch {
    return "US";
  }
};

const CurrencyAutoDetect = () => {
  const { updateActiveFilter } = useFiltersStore((state) => state.actions);

  useEffect(() => {
    if (typeof window === "undefined" || localStorage.getItem(LS_KEY)) return;

    const countryCode = detectCountryFromTimezone();
    const currency = COUNTRY_TO_CURRENCY[countryCode] ?? "USD";

    if (currency !== "USD") {
      updateActiveFilter("currency", [{ id: 0, included: true, label: currency, value: currency }]);
    }

    localStorage.setItem(LS_KEY, "1");
  }, [updateActiveFilter]);

  return null;
};

export default CurrencyAutoDetect;
